import { Validator } from '@vista-digital/validator';
import { fieldDisplayTextValidatorSchema } from '../../types/field-display-text';
export const captchaFieldDisplayTextValidator = Validator.object({
    requiredMessage: fieldDisplayTextValidatorSchema.requiredMessage
});
export const defaultCaptchaFieldDisplayText = {
    requiredMessage: "Please verify you're not a robot."
};
//# sourceMappingURL=display-text.js.map